import { customerSchema } from '../bits-api/customer';
import { whoamiSchema } from '../bits-api/whoami';

export const meSchema = whoamiSchema.extend({
  customer: customerSchema.optional().nullable(),
});
